// LoadPlugin.js
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export default function LoadPlugin({ initialJson }) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!initialJson) return;
        try {
            const editorState = editor.parseEditorState(initialJson);
            editor.setEditorState(editorState);
        } catch (err) {
            console.error("Failed to load editor content:", err);
        }
    }, [initialJson, editor]);

    return null;
}
